import { TransformConvertorBase } from './transform.convertor';
import { Transformation } from 'app/model/dataflow/transformation';
import { DataFlowExpressionUtils } from 'app/model/adapters/dataflow/expression.util';
import { BaseSortPlainObject } from 'worker/app-workers/shared/plainObjects/baseSort.plainObject';
import { BaseSortTransformation } from 'app/model/dataflow/basesorttransformation';
import { BooleanDataFlowType } from 'app/model/dataflow/dataflow-datatype';
import { IResourceContext } from 'shell-models-lib';

export class BaseSortConvertor extends TransformConvertorBase {
    private get sortTransform(): BaseSortTransformation {
        return this.transformation as BaseSortTransformation;
    }

    private get sortObject(): BaseSortPlainObject {
        return this.transformObject as BaseSortPlainObject;
    }

    public async convert(contextData: IResourceContext): Promise<Transformation> {
        await super.convert(contextData);
        this.sortObject.sortExpressions.forEach((sortExpression) => {
            const expression = this.sortTransform.addSortExpression();
            expression.dataFlowExpression.expression = DataFlowExpressionUtils.unwrapExpressionWithEmptyValue(
                sortExpression.expression
            );
            expression.ascending = sortExpression.ascending;
            expression.nullsFirst = sortExpression.nullsFirst;
        });

        this.sortObject.configs.forEach((expression, configName) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (this.sortTransform as any)[configName] = DataFlowExpressionUtils.unwrapExpressionConfigValue(
                expression,
                this.sortTransform,
                BooleanDataFlowType.TYPE
            );
            this._handledConfigs.push(configName);
        });
        super.postConvert();
        return this.transformation;
    }
}
